import { Box, Link, Stack, Typography } from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          p: 4,
          bgcolor: "secondary.main",
          display: "flex",
          justifyContent: "center"
        }}
        className="page-footer"
      >
        <Box>
          <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 3 }}>
            <Link
              href="https://www.edsn.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/EDSN_tagline_Wit_x56.png`}
                alt="EDSN"
              />
            </Link>
            <Link
              href="https://www.westlandinfra.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/WestlandInfraWhite.svg`}
                alt="EDSN"
              />
            </Link>
            <Link
              href="https://www.rendogroep.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/RendoWhite.svg`}
                alt="EDSN"
              />
            </Link>
            <Link
              href="https://www.stedin.net/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/StedinWhite.svg`}
                alt="EDSN"
              />
            </Link>
            <Link
              href="https://coteqnetbeheer.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/CoteqWhite.svg`}
                alt="EDSN"
              />
            </Link>
            <Link
              href="https://www.liander.nl/consument"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/LianderWhite.svg`}
                alt="EDSN"
              />
            </Link>
            <Link
              href="https://www.enexis.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/EnexisWhite.svg`}
                alt="EDSN"
              />
            </Link>
          </Stack>
        </Box>
      </Box>
      <Box
        sx={{
          p: 2,
          bgcolor: "secondary.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Box>
          <Stack direction="row" spacing={2}>
            <Typography variant="body2" color="secondary.contrastText">
              Copyright © 2021
            </Typography>
            <Link
              variant="body2"
              underline="hover"
              color="secondary.contrastText"
              href={`${process.env.REACT_APP_PIE_BASE_URL}/privacy`}
            >
              Privacy
            </Link>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
